/*
 * Module for DROP Account - Index
 */
rs.module("content/participant/drop/account/index",

    [ /* dependencies */ ],

    function () {

        function initialize(jsSelectors, cssSelectors, backendUrls) {

            var dropAccountForm = $.js(jsSelectors.dropAccountForm);

            var historyContainer = dropAccountForm.js(jsSelectors.historyContainer);
            var historyPanel = dropAccountForm.js(jsSelectors.historyPanel);

            var modalContainer = $.js(jsSelectors.modalContainer);        
            var modalLoadingSpinner = modalContainer.js(jsSelectors.modalLoadingSpinner);
            var interestDetailsModal = modalContainer.js(jsSelectors.interestDetailsModal);
            var interestDetailsContent = modalContainer.js(jsSelectors.interestDetailsContent);

            // show/hide DROP account status history on hover with intent
            historyContainer.hoverIntent({
                handlerOver: function (event) {
                    historyPanel.toggleClass(cssSelectors.visible, true);
                },
                handlerOut: function (event) {
                    historyPanel.toggleClass(cssSelectors.visible, false);
                },
                hoverOutDelay: 400
            });

            // Handle the interest details link button click.
            $(document).onjs("click", jsSelectors.viewModalLink, function(event) {

                var dropTransactionKey = $(this).data("droptransactionkey");

                // show loading spinner
                modalLoadingSpinner.show();

                $.get(
                    backendUrls.loadInterestDetailsAsync,
                    {
                        dropTransactionKey: dropTransactionKey
                    }

                ).done(function (results) {
                    interestDetailsModal.modal('show');
                    interestDetailsContent.html(results);
                }
                ).always(function () {

                    // hide loading spinner
                    modalLoadingSpinner.hide();
                });         
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);